import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Row, Col, Space, Typography, Grid, Card, Button } from 'antd';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Success() {
  const { xs, xl, xxl } = useBreakpoint()
  let history = useHistory()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, []);

  const { data } = history.location.state
  const type = (
    data?.type === 'PARTICIPANT' ?
      'Participant'
    : data?.type === 'POSTER_PRESENTER' ?
      'Presenter Poster'
    : data?.type === 'PRESENTER_ORAL' ?
      'Presenter Oral'
    : data?.type === 'ATLANTIS' ?
      'Atlantis'
    : null
  )
  return (
    <React.Fragment>
      <Space direction='vertical' size={xs ? 16 : 64} style={{ padding: xxl ? '80px 300px' : xl ? '40px 160px' : '26px 8px', width: '100%', backgroundColor: '#fff' }}>
        <Card style={{ width: '100%', padding: xxl ? '32px 64px' : xl ? '8px 16px' : 0  }}>
          <Space direction='vertical' size={xs ? 8 : 16} style={{ width: '100%' }}>
            <Space direction='vertical' size={xs ? 4 : 8}>
              <Text style={{ fontSize: xs ? 20 : 30, fontWeight: 'bold', color: '#0D6E49' }}>Thank You</Text>
            </Space>
            <Space direction="vertical" size={10}>
              <Text>You have registered as a <Text style={{ fontWeight: 'bold', color: '#0D6E49' }}>{type}</Text></Text>
              {/* <Text style={{ fontSize: xs ? 16 : 20, fontWeight: 'bold' }}>THIS REGISTRATION PROOF HAS BEEN SENT TO YOUR EMAIL</Text> */}
              <Space direction='vertical' size={0}>
                <Text style={{ fontSize: xs ? 16 : 20, fontWeight: 'bold' }}>THIS REGISTRATION HAS BEEN SUCCESS</Text>
                <Text style={{ fontSize: xs ? 14 : 18, fontWeight: 250 }}>Don't forget to <Text style={{ color: '#0D6E49', fontWeight: 800 }}>Screenshot</Text> this page to save your Registration Number.</Text>
              </Space>
            </Space>
            <Text>Your Registration Number: <Text strong>{data?.transactionNumber}</Text></Text>
              <Text>Please make payment via:</Text>
              <Space direction="vertical" size={8}>
                <Space direction="vertical" size={2}>
                  <Text >Wire transfer</Text>
                  <Text>Bank Name: Bank Negara Indonesia (BNI)</Text>
                  <Text>Account Number: <Text copyable>289127427</Text></Text>
                  <Text>Account Name: Yayasan Binawan</Text>
                  <Text>Swift code: <Text type='danger'>BNINIDJAXXX (only for foreign bank transfers)</Text></Text>
                </Space>
              </Space>
          </Space>
          <Row gutter={[8,8]} style={{ textAlign: 'center', marginTop: 32 }}>
            <Col xs={0} xl={2}></Col>
            <Col xs={24} xl={10}>
              <Link to="/registration/payment-confirmation">
                <Button className='button-green' block>Upload Bukti Pembayaran</Button>
              </Link>
            </Col>
            <Col xs={24} xl={10}>
              <Link to="/">
                <Button className='button-back' block>Halaman Utama</Button>
              </Link>
            </Col>
            <Col xs={0} xl={2}></Col>
          </Row>
        </Card>
      </Space>
    </React.Fragment>
  )
}

export default Success